import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

export const useAccountStatusLoader = ({ token, user }) => {
  const [accountStatus, setAccountStatus] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || !user) return;
    const perform = async () => {
      const url = `${BASE_URL}subscription/status?email=${user.email}`;
      const res = await fetch(url, {
        headers: { Authorization: token },
      }).catch((err) => {
        console.error("Error fetching subscription status:", err);
        navigate("/entrar?refresh=true");
      });
      if (res.ok) {
        const status = await res.json();
        setAccountStatus(status);
        setAccountStatusIfTrial(status);
      } else {
        console.error("Error fetching subscription status:", res?.status);
      }
    };
    perform();

    // If the account is not active but the user is on a trial, set the account status accordingly
    const setAccountStatusIfTrial = (status) => {
      if (!status?.isAccountActive && user.onTrial) {
        setAccountStatus({
          isAccountActive: false,
          isAccountPremium: true,
          onTrial: true,
          accessExpiryDate: null,
        });
      }
    };
  }, [token, user]);

  return { accountStatus };
};
